import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'core_collections-quick_add_tracking-click';
/**
 * This event is to record request id for product clicks on the collection page
 */
export function trackCoreCollectionsQuickAddTrackingClick(productToken, Request_Id_string) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { productToken, Request_Id_string },
    });
}
